import { Box, Button, Grid2, IconButton, styled } from '@mui/material';
import palette from '../../../../theme/colors-palette';

export const FullScreenImageButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  zIndex: 150,
  top: '1rem',
  right: 0,
  marginRight: '8px',
  color: theme.palette.colors.white,
  background:
    'radial-gradient(circle, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0) 75%)',
}));

export const ImageRightButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  zIndex: 150,
  top: '9rem',
  color: theme.palette.colors.white,
  background:
    'radial-gradient(circle, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0) 75%)',
  right: 0,
  '&:active': {
    boxShadow: 'none',
  },
  '&:hover': {
    boxShadow: 'none',
  },
  '&:focus': {
    boxShadow: 'none',
  },
}));

export const ImageLeftButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  zIndex: 150,
  top: '9rem',
  color: theme.palette.colors.white,
  background:
    'radial-gradient(circle, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0) 75%)',
  left: 0,
  '&:active': {
    boxShadow: 'none',
  },
  '&:hover': {
    boxShadow: 'none',
  },
  '&:focus': {
    boxShadow: 'none',
  },
}));

export const MainBox = styled(Box)(() => ({
  position: 'relative',
  marginBottom: '1.5rem',
  borderRadius: '15px',
  display: 'flex',
  width: '100%',
  height: 0,
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  minHeight: '20rem',
  minWidth: '11.25rem',
}));

export const StyledIFrame = styled('iframe')(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  background: 'transparent',
  width: '100%',
  height: '100%',
  maxWidth: '100%',
}));

export const ButtonBook = styled(Button)(() => ({
  display: 'flex',
  background: palette.utriper.lightblue,
  fontWeight: 'bold',
  color: 'white',
  '&:hover': {
    backgroundColor: palette.utriper.darkblue,
  },
}));

export const DescriptionWrapper = styled(Grid2)(({ theme }) => ({
  marginLeft: '1rem',
  [theme.breakpoints.down('lg')]: {
    marginLeft: '.5rem',
  },
}));

export const CopyLinkWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginRight: '1px',
  },
}));
